import { SubmitOrderFailure } from 'components/ordering/SubmitOrderFailure'
import { SubmitOrderForm } from 'components/ordering/SubmitOrderForm'
import { SubmitOrderProgressView } from 'components/ordering/SubmitOrderProgressView'
import { SubmitOrderSuccess } from 'components/ordering/SubmitOrderSuccess'
import { TypeRoute } from 'core/TypeRoute'
import { useCurrentStore, useOrdering } from 'hooks'
import { ReactNode, useEffect } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

interface Section {
  label: string
  name: string
  element: () => ReactNode
}

export interface StoreMenuPageState {
  sections: Section[]
  currentSectionIndex: number
}

export const TableSubmitOrderPage = () => {
  const { store } = useCurrentStore()
  const { order } = useOrdering()
  const { tableId } = useParams()
  const navigate = useNavigate()

  const {
    submitOrderState: { isSubmitting, isSuccess, isError },
  } = useOrdering()

  const backUrl = generatePath(TypeRoute.TableOrdering, {
    storeId: store.id,
    tableId: tableId!,
  })
  useEffect(() => {
    if (!order || order.total === 0) {
      navigate(backUrl)
    }
  }, [order]) // eslint-disable-line react-hooks/exhaustive-deps

  return isError ? (
    <SubmitOrderFailure
      tryAgainUrl={generatePath(TypeRoute.TableSubmitOrder, {
        storeId: store!.id,
        tableId: tableId!,
      })}
    />
  ) : isSuccess ? (
    <SubmitOrderSuccess backUrl={backUrl} showOrderDetail={true} />
  ) : (
    <>
      <SubmitOrderForm
        acceptOrderInfo={false}
        acceptFootnotes={false}
        acceptTip={store.table_ordering_settings?.show_tip ?? false}
        acceptPayment={
          store.table_ordering_settings?.show_payment_info ?? false
        }
        acceptCustomerInfo={
          store.table_ordering_settings?.show_customer_info ?? false
        }
        acceptPromoCode={
          store.table_ordering_settings?.show_customer_info ?? false
        }
        backUrl={backUrl}
      />
      {isSubmitting && <SubmitOrderProgressView />}
    </>
  )
}
